module.exports = __webpack_public_path__ + "static/media/select.e4eafe50.webp";